import React from "react";

type FaqsData = {
  question: string;
  answer: JSX.Element | string;
};

const linkSpan = (text: string, href: string) => (
  <>
    {" "}
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="cursor-pointer underline"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {text}
    </a>
  </>
);

const faqsData: FaqsData[] = [
  {
    question: "Is Gondola free to use?",
    answer:
      "Yes. Gondola is completely free. There are no added fees or hidden costs, just smarter bookings and more rewards.",
  },
  {
    question: "How does Gondola make money?",
    answer:
      "Gondola earns revenue from when you book hotels and rental cars directly through Gondola, and we share a portion of that back with you as Gondola Cash. You keep all your direct loyalty points and status perks, plus extra cash back on top.",
  },
  {
    question: "How does booking with Gondola earn me the most points?",
    answer: (
      <span>
        When you book with Gondola, you get booked directly with hotels and
        triple stack your earnings. You&apos;ll earn your usual hotel points,
        status nights, and credit card points, stacked with 3-7% Gondola Cash
        back. This means you&apos;re earning an average of 16% back with Gondola
        every time.
        {linkSpan("Search for your next destination", "/hotel/search")}
      </span>
    ),
  },
  {
    question: "How is Gondola better than other travel booking sites?",
    answer: (
      <span>
        Unlike other sites, Gondola books directly with hotels, so you keep all
        your loyalty perks and status benefits while earning an extra 3-7%
        Gondola Cash back. You can compare rates across every major hotel brand,
        see cash and points side by side, and get personalized recommendations.
        Gondola also tracks price drops, automatically rebooks lower rates, and
        keeps all your travel loyalties in one dashboard.
        {linkSpan("See my points", "/loyalty-dashboard")}
      </span>
    ),
  },
  {
    question:
      "Will I still earn hotel loyalty points, perks, and elite nights?",
    answer:
      "Yes. Every booking is processed directly with the hotel, so you earn your full hotel loyalty points, status nights, and credit card points, plus 3-7% Gondola Cash back on top.",
  },
  {
    question: "How does Gondola track my points automatically?",
    answer: (
      <span>
        By connecting your email, Gondola scans travel confirmation emails from
        verified providers and updates your loyalty balances, points values, and
        your travel history. The average traveler discovers over $3000 in unused
        travel points this way.
        {linkSpan("See your points", "/loyalty-dashboard")}
      </span>
    ),
  },
  {
    question: "How does AutoSave save me money?",
    answer:
      "Enable AutoSave and link a card on your Trips page to let Gondola automatically reprice your stays at Marriott, Hyatt, or IHG. If we catch a price drop, Gondola updates your rate and you keep 100% of the savings. You can still use a different card at check-in to earn your preferred rewards. Travelers save an average of $413 a year using AutoSave!",
  },
  {
    question: "What is Gondola Cash and how can I earn it?",
    answer:
      'Gondola Cash is our rewards "currency". $1 in Gondola Cash equals $1 toward your next hotel booking. You earn 3% Gondola Cash back on every cash booking. You can also earn Gondola Cash by referring friends to Gondola.',
  },
  {
    question: "Does Gondola have a mobile app?",
    answer:
      "Yes. You can download Gondola in the iOS App Store and in the Google Play Store.",
  },
];
export { faqsData };
